import { createApp } from 'vue';
import globals from '@/globals';
import root from '@/view/vue/index.vue';
import router from '@/router';
import setupLocale from '@/helpers/setup-locale';
import store from '@/store';

setupLocale();

const app = createApp(root);

app.use(store);
app.use(router);

/** initialize global vue plugins, components, directives, filters, and mixins */
globals.initialize(app);

app.mount('#app');


export default app;
